/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  makeStyles,
  lighten,
  withStyles,
  useTheme
} from "@material-ui/core/styles";
import {
  TextField,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  MenuItem,
  Select,
  IconButton,
  TableFooter,

  Divider,
  List,
  ListItem,
  Checkbox,
  Grid,
  ListItemText,
  ListItemIcon,
  Card,
  CardHeader,
} from "@material-ui/core";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

import * as moment from 'moment';

import { getAccessList, registerAccess, deleteAccess } from "../modules/Auth/_redux/inOutAccessCrud";
import { getDoorList } from "../modules/Auth/_redux/doorCrud";

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

const useStyles4 = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  margin: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const StyledTableCell4 = withStyles(theme => ({
  head: {
    backgroundColor: '#298BA8', // theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

const StyledTableRow4 = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default
    }
  }
}))(TableRow);

// Example 5
const useStyles52 = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3)
  },
  table: {
    minWidth: 500
  },
  tableWrapper: {
    overflowX: "auto"
  }
}));

const useStyles51 = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5)
  }
}));

function TablePaginationActions5(props) {
  const classes = useStyles51();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  function handleFirstPageButtonClick(event) {
    onChangePage(event, 0);
  }

  function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  }

  function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  }

  function handleLastPageButtonClick(event) {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  }

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="First Page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="Previous Page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Next Page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Last Page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions5.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};


const useStyles = makeStyles(theme => ({
  root: {
    margin: "auto"
  },
  paper: {
    width: 200,
    height: 230,
    overflow: "auto"
  },
  button: {
    margin: theme.spacing(0.5, 0)
  }
}));

function not(a, b) {
  return a.filter(value => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter(value => b.indexOf(value) !== -1);
}

// Example 2
const useStyles2 = makeStyles(theme => ({
  root: {
    margin: "auto"
  },
  cardHeader: {
    padding: theme.spacing(1, 2)
  },
  list: {
    width: 200,
    height: 230,
    backgroundColor: theme.palette.background.paper,
    overflow: "auto"
  },
  button: {
    margin: theme.spacing(0.5, 0)
  }
}));

function not2(a, b) {
  return a.filter(value => b.indexOf(value) === -1);
}

function intersection2(a, b) {
  return a.filter(value => b.indexOf(value) !== -1);
}

function union2(a, b) {
  return [...a, ...not2(b, a)];
}

// var accessList = [];
var doorList = [];

export function InOutAuthPage({ history }) {

  var m = moment();
  var _endDt = m.format('YYYY-MM-DD')
  var _startDt = m.add(-30, 'days').format('YYYY-MM-DD')

  const [accessList, setAccessList] = React.useState([]);
  // const [doorList, setDoorList] = React.useState('');
  const [refresh, setRefresh] = React.useState('');
  const [authName, setAuthName] = React.useState('');
  const [authDesc, setAuthDesc] = React.useState('');

  const [showNew, setShowNew] = React.useState(false);
  const [showAskSave, setShowAskSave] = React.useState(false);
  const [showAskDelete, setShowAskDelete] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const [title, setTitle] = React.useState('Error');
  const [errorMsg, setErrorMsg] = React.useState('');
  const [showSnack, setShowSnack] = React.useState(false);

  function handleCloseSnack() {
    setShowSnack(false)
  }

  function handleCloseAskDelete() {
    setShowAskDelete(false);
  }

  function handleActionDelete() {

    setShowAskDelete(false);

    console.log(selectedRow)

    const fetchData = async () => {
      try {
        const result = await deleteAccess(selectedRow.id)

        console.log('DELETE DEVICE1', result)

        if(result.data.resultCode != 'ok') {
          setTitle('Error')
          setErrorMsg(result.data.message);
          setShowSnack(true);
          return;
        }

        searchDoorList();
        searchAccessList();

      } catch (error) {
        console.log('DELETE DEVICE2', error);
        setTitle('Error')
        setErrorMsg(error.toString());
        setShowSnack(true);
      }
    };
    fetchData();
  }


  function handleCloseNew() {
    setShowNew(false);
  }

  function newButtonClick() {
    setShowNew(true);
  }

  
  function handleClickAskDelete(row) {
    setSelectedRow(row);
    setShowAskDelete(true);
  }

  function handleCheckSave() {
    
    if (authName == null || authName == '') {
      setTitle('Error')
      setErrorMsg('권한 이름을 입력해 주세요.')
      setShowSnack(true);
      return;
    }

    if (authDesc == null || authDesc == '') {
      setTitle('Error')
      setErrorMsg('설명을 입력해 주세요.')
      setShowSnack(true);
      return;
    }

    if(right2.length == 0){
      setTitle('Error')
      setErrorMsg('출입문을 1개 이상 선택해 주세요.')
      setShowSnack(true);
      return;
    }

    setShowAskSave(true);
  }

  function handleActionSave() {

    setShowAskSave(false);

    right2.map(index => console.log(doorList[index]));

    var doorIds = right2.map(index => doorList[index].id)

    const fetchData = async () => {
      try {
        const result = await registerAccess(authName, authDesc, doorIds);

        console.log('REGISTER DEVICE', result)

        if(result.data.resultCode != 'ok') {
          setTitle('Error')
          setErrorMsg(result.data.message);
          setShowSnack(true);
          return;
        }

        setShowNew(false)
        searchDoorList();
        searchAccessList();

      } catch (error) {
        console.log('REGISTER DEVICE', error);
        setTitle('Error')
        setErrorMsg(error.toString());
        setShowSnack(true);
      }
    };
    fetchData();
  }

  function searchDoorList() {

    const fetchData = async () => {
      try {
        const result = await getDoorList();

        console.log('DOORS', result)

        var _doorList = [];
        var hists = result.data.list;

        for (var ii = 0; ii < hists.length; ii++) {
          var hist = hists[ii];

          if (hist.createDt != null && hist.createDt != '')
            hist.createDt = hist.createDt.substr(0, 10) + ' ' + hist.createDt.substr(11, 5);

          if (hist.updateDt != null && hist.updateDt != '')
            hist.updateDt = hist.updateDt.substr(0, 10) + ' ' + hist.updateDt.substr(11, 5);

            _doorList = [..._doorList, hist]
        }
        
        // setDoorList(_doorList);
        doorList = _doorList;
        setLeft2(range(0, result.data.list.length, 1));

        setRefresh('REFRESH')
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }

  function searchAccessList() {

    const fetchData = async () => {
      try {
        const result = await getAccessList();

        console.log('ACCESS LIST', result)
        var _accessList = [];
        var hists = result.data.list;

        for (var ii = 0; ii < hists.length; ii++) {
          var hist = hists[ii];

          /*
          createDt: "2021-04-19 02:11"
          id: 54
          nm: "ROLE_DOOR_RW"
          updateDt: "2021-04-19 02:11" */


          if (hist.createDt != null && hist.createDt != '')
            hist.createDt = hist.createDt.substr(0, 10) + ' ' + hist.createDt.substr(11, 5);

          if (hist.updateDt != null && hist.updateDt != '')
            hist.updateDt = hist.updateDt.substr(0, 10) + ' ' + hist.updateDt.substr(11, 5);

          _accessList = [..._accessList, hist]
        }
        setAccessList(_accessList);

        setRefresh('REFRESH')
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }

  function handleChangeAuthName(event) {
    setAuthName(event.target.value);
  }

  function handleChangeAuthDesc(event) {
    setAuthDesc(event.target.value);
  }


  const classes4 = useStyles4();
  const classes5 = useStyles52();

  const [page5, setPage5] = React.useState(0);
  const [rowsPerPage5, setRowsPerPage5] = React.useState(10);

  const emptyRows5 =
    rowsPerPage5 - Math.min(rowsPerPage5, accessList.length - page5 * rowsPerPage5);

  function handleChangePage5(event, newPage) {
    setPage5(newPage);
  }

  function handleChangeRowsPerPage5(event) {
    setRowsPerPage5(parseInt(event.target.value, 10));
  }

  useEffect(() => {
    searchDoorList();
    searchAccessList();
  }, [])

  const samples = [ ];

  const range = (from, to, step) =>
  [...Array(Math.floor((to - from) / step) + 1)].map((_, i) => from + i * step);

  const classes2 = useStyles2();
  const [checked2, setChecked2] = React.useState([]);
  // const [left2, setLeft2] = React.useState(Array.from(Array(deviceList.length).keys()));
  const [left2, setLeft2] = React.useState(range(0, doorList.length, 1));
  const [right2, setRight2] = React.useState([]);

  const leftChecked2 = intersection2(checked2, left2);
  const rightChecked2 = intersection2(checked2, right2);

  const handleToggle2 = value => () => {
    const currentIndex2 = checked2.indexOf(value);
    const newChecked2 = [...checked2];

    if (currentIndex2 === -1) {
      newChecked2.push(value);
    } else {
      newChecked2.splice(currentIndex2, 1);
    }

    setChecked2(newChecked2);
  };

  const numberOfChecked2 = items => intersection2(checked2, items).length;

  const handleToggleAll2 = items => () => {
    if (numberOfChecked2(items) === items.length) {
      setChecked2(not2(checked2, items));
    } else {
      setChecked2(union2(checked2, items));
    }
  };

  const handleCheckedRight2 = () => {
    setRight2(right2.concat(leftChecked2));
    setLeft2(not2(left2, leftChecked2));
    setChecked2(not2(checked2, leftChecked2));
  };

  const handleCheckedLeft2 = () => {
    setLeft2(left2.concat(rightChecked2));
    setRight2(not2(right2, rightChecked2));
    setChecked2(not2(checked2, rightChecked2));
  };

  const customList2 = (title, items) => (
    <Card>
      <CardHeader
        className={classes2.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll2(items)}
            checked={
              numberOfChecked2(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked2(items) !== items.length &&
              numberOfChecked2(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ "aria-label": "모두 선택됨" }}
          />
        }
        title={title}
        subheader={`${numberOfChecked2(items)}/${items.length} 선택됨`}
      />
      <Divider />
      <List className={classes2.list} dense component="div" role="list">
        {items.map(value => {
          
          if(doorList[value] == null) return;

          const doorNm = doorList[value].nm;
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle2(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked2.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={doorNm} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  return (
    <>

      <div className="row">
        <div className="col-md-2">

          <TextField
            id="standard-name"
            label="권한이름"
            className={classes4.textField}
            onChange={handleChangeAuthName}
            margin="normal"
          />

        </div>

        <div className="col-md-2">
          <Button variant="contained" color="secondary" className={classes4.button}
            onClick={searchAccessList}
            style={{
              position: 'absolute',
              bottom: '8px',
              left: '18px'
            }}>
            검색
            <SearchIcon className={classes4.rightIcon} />
          </Button>
        </div>
        <div className="col-md-8">
          <Button variant="contained" color="secondary" className={classes4.button}
            onClick={newButtonClick}
            style={{
              position: 'absolute',
              bottom: '8px',
              right: '18px'
            }}>
            권한추가
            <SearchIcon className={classes4.rightIcon} />
          </Button>
        </div>
      </div>

      {/*<div className="separator separator-dashed my-7"></div>*/}
      <div className="row">
        <div className="col-md-12">

          <Paper className={classes5.root}>
            <div className={classes5.tableWrapper}>
              <Table className={classes5.table}>

                <TableHead>
                  <TableRow>
                    <StyledTableCell4 style={{ width: '100px' }} align="center">권한번호</StyledTableCell4>
                    <StyledTableCell4 align="left">권한이름</StyledTableCell4>
                    <StyledTableCell4 align="left">등록일시</StyledTableCell4>
                    <StyledTableCell4 align="left">수정일시</StyledTableCell4>
                    <StyledTableCell4 align="center"> </StyledTableCell4>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {accessList
                    .slice(
                      page5 * rowsPerPage5,
                      page5 * rowsPerPage5 + rowsPerPage5
                    )
                    .map(row => (
                      <TableRow key={row.name}>
                        <TableCell component="th" scope="row" align="center">
                          {row.id}
                        </TableCell>

                        <TableCell align="left">{row.nm}</TableCell>
                        <TableCell align="left">{row.createDt}</TableCell>
                        <TableCell align="left">{row.updateDt}</TableCell>
                        <TableCell align="center" style={{ padding: '0' }}>

                          <Button size="small" className={classes4.margin}
                            onClick={handleClickAskDelete.bind(this, row)}
                            style={{ color: 'orangered', margin: 0 }}>
                            <DeleteIcon className={classes4.deleteIcon} />
                          </Button>
                        </TableCell>

                      </TableRow>
                    ))}

                  {emptyRows5 > 0 && (
                    <TableRow style={{ height: 48 * emptyRows5 }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      // rowsPerPageOptions={[5, 10, 25]}
                      colSpan={3}
                      count={accessList.length}
                      rowsPerPage={rowsPerPage5}
                      page={page5}
                      /*SelectProps={{
                        inputProps: { "aria-label": "Rows per page" },
                        native: true
                      }}*/
                      onChangePage={handleChangePage5}
                      onChangeRowsPerPage={handleChangeRowsPerPage5}
                      ActionsComponent={TablePaginationActions5}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </Paper>

        </div>

      </div>

      <Dialog
        open={showAskDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"장치 삭제"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 권한을 삭제하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAskDelete} color="primary">
            아니오
          </Button>
          <Button onClick={handleActionDelete} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAskSave}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"출입 권한 등록"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            이 출입 권한을 등록하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNew} color="primary">
            아니오
          </Button>
          <Button onClick={handleActionSave} color="primary" autoFocus>
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showSnack}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ minWidth: '320px' }}
      >
        <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSnack} color="primary" autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={showNew}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">출입 권한 등록</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ visibility: 'hidden' }}>sldflasjdf;lajsd;lfkjas;ldkfja;lsdkfja;oiejo;aisjdf;lasdjfl;aisjdfl;ajsdf;oiajef;iljasd;fljasd;lkfjas;ldkfja;oiwefjl;asdjf;lasdjf;lkasjdf;lksajdf;ljasd;lkf
            </div>
          </DialogContentText>

          <div className="row">

            <div className="col-md-4">
              <TextField
                autoFocus
                margin="dense"
                id="name"
                onChange={handleChangeAuthName}
                label="출입권한명"
                type="text"
                fullWidth
              />
            </div>

            <div className="col-md-8">
              <TextField
                margin="dense"
                id="name"
                label="설명"
                onChange={handleChangeAuthDesc}
                type="text"
                fullWidth
              />
            </div>
          </div>

          <div className="separator separator-dashed my-7" />

          <div className="row">

            <div className="col-md-12">
              <Grid
                container
                spacing={2}
                justify="center"
                alignItems="center"
                className={classes2.root}
              >

                <Grid item>{customList2("전체 출입문 목록", left2)}</Grid>
                <Grid item>
                  <Grid container direction="column" alignItems="center">
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes2.button}
                      onClick={handleCheckedRight2}
                      disabled={leftChecked2.length === 0}
                      aria-label="move selected right"
                    >
                      <i className="flaticon2-next" />
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      className={classes2.button}
                      onClick={handleCheckedLeft2}
                      disabled={rightChecked2.length === 0}
                      aria-label="move selected left"
                    >
                      <i className="flaticon2-back" />
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>{customList2("선택된 출입문 목록", right2)}</Grid>
              </Grid>
            </div>
          </div>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNew} color="primary">
            취소
          </Button>
          <Button onClick={handleCheckSave} color="primary">
            저장
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}


